class Toggle {
	constructor() {
		this.toggle = document.querySelector('.toggle');
		this.showNavigationMobile();
	}

	showNavigationMobile() {
		const navigation = document.querySelector('.navigation-mobile');
		// const overlayElement = document.createElement('div');
		// overlayElement.id = 'navigation-overlay';
		// document.body.appendChild(overlayElement);
		const overlay = document.getElementById('navigation-overlay');

		if (this.toggle && navigation) {
			this.toggle.addEventListener('click', () => {
				navigation.classList.toggle('open');
				this.toggle.classList.toggle('toggle-close');
				document.body.classList.toggle('navigation-no-scroll');
				overlay.classList.toggle('show-navigation-overlay');
			});
		}

		if (overlay) {
			overlay.addEventListener('click', () => {
				navigation.classList.toggle('open');
				this.toggle.classList.toggle('toggle-close');
				document.body.classList.toggle('navigation-no-scroll');
				overlay.classList.toggle('show-navigation-overlay');
			});
		}
	}
}

new Toggle();
